import { FunctionComponent, useCallback, useState } from 'react'
import { Button, ConexaLogo, Text } from '@conexasaude/conexa-hero'
import { useParams, useHistory } from 'react-router'
import { RenderIf } from '@/components/RenderIf'
import { HeroWrapper } from '@/styles/rebranded/HeroWrapper'
import { useFirebaseContext } from '@/modules/Firebase/contexts/FirebaseContext'
import useStyles from './styles'
interface IStartFormProps {
  onClickLogin(): void
}

const StartForm: FunctionComponent<IStartFormProps> = ({ onClickLogin }) => {
  const params = useParams<{ clinic?: string }>()
  const { push } = useHistory()
  const [imageError, setImageError] = useState(false)
  const { logAnalyticsEvent } = useFirebaseContext()
  const styles = useStyles()

  const goToSignUp = useCallback(() => {
    logAnalyticsEvent('Pac_Login_CriarConta')
    push('/cadastro/inicio')
  }, [push, logAnalyticsEvent])

  return (
    <HeroWrapper>
      <div css={styles.startForm}>
        <RenderIf condition={!!params.clinic && !imageError}>
          <img
            src={`${process.env.REACT_APP_LINK_LOGO_AWS}${params.clinic}.png`}
            alt="logo"
            css={styles.logoWhiteLabel}
            onError={event => {
              event.currentTarget.onerror = null
              setImageError(true)
              event.currentTarget.style.height = 'auto'
            }}
          />
        </RenderIf>
        <RenderIf condition={!params.clinic || imageError}>
          <ConexaLogo base="colorful" inverse width={270} height={60} />
        </RenderIf>

        <Text variant="headingXLarge" css={styles.title}>
          Conecte-se à sua saúde
        </Text>
        <Text variant="headingMedium" css={styles.subtitle}>
          Crie uma conta para agendar ou realizar consultas
        </Text>
        <Button css={styles.buttonLogin} onClick={goToSignUp} fullWidth>
          Criar conta
        </Button>

        <Button
          css={styles.buttonLogin}
          onClick={onClickLogin}
          fullWidth
          variant="secondary"
        >
          Acessar conta
        </Button>
      </div>
    </HeroWrapper>
  )
}

export default StartForm
